import moment from 'moment'
import intervalUnits from '../data/intervalUnits.json'

export const formatTimeString = (time, second) => {
    const [hours, minutes] = time.split(':').slice(0, 2)
    const formattedHour = hours === '24' ? '00' : hours
    return second ? `${formattedHour}:${minutes}:${second}` : `${formattedHour}:${minutes}`
}

export const convertToSeconds = (value, unit) => {
    const unitInfo = intervalUnits?.[unit]
    return value * (unitInfo?.interval || 1)
}

export const compareTimes = (time1, time2) => {
    return time1?.localeCompare(time2)
}

export const getValueFromTime = (time, index) => time.split(':')?.[index] || null

export const modifyUTCDate = (date, time) => {
    const dateMoment = moment(date)
    const timeMoment = moment(time)
    const combinedMoment = dateMoment.set({
        hour: timeMoment.hour(),
        minute: timeMoment.minute(),
        second: timeMoment.second()
    })
    return combinedMoment.utc()
}
export const formatToISOUTC = (date) => moment(date).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')

class Date {
    addZero = num => {
        return num.toString().padStart(2, '0')
    }

    timeFormatter = duration => {
        const hours = Math.floor(duration / 60)
        const minutes = duration - hours * 60
        return {
            hours: hours,
            minutes: minutes,
            hourText: hours === 1 ? 'hour' : 'hours',
            minuteText: minutes === 1 ? 'minute' : 'minutes'
        }
    }

    convertDate = date => moment(date).format('dddd, DD MMMM YYYY [at] HH:mm:ss [GMT]Z')

    convertDateToUTC = date => moment(date).format('DD/MM/YYYY, HH:mm:ss [UTC]')

    convertToFormattedUTC = date => moment(date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]')

    convertToTimeZone = (date, format, time) => {
        const momentObj = format ? moment(date, format) : moment(date)
        return momentObj.format(`YYYY-MM-DD[T]${time || 'HH:mm:ss'}[Z]`)
    }

    convertToReadableDate = date => moment(date).format('DD/MM/YYYY HH:mm')

    convertToDateOnly = (date, format) => format ? moment(date, format).format('DD/MM/YYYY') : moment(date).format('DD/MM/YYYY')

    convertToStandartDate = (date, format) => format ? moment(date, format).format('DD.MM.YYYY') : moment(date).format('DD.MM.YYYY')

    convertSlashDateToJSDate = (date, format) => moment(date, format).toDate()
}

export default new Date()
